import { FluentBundle } from 'fluent';
import React from 'react';
import { ProductClass, ProductYear } from '../../graphQL/types/shared';
import { gql, useQuery } from '../../graphQL/useQuery';
import { generateStringProductId } from '../../graphQL/Utils';
import { getCountryName } from '../../Utils';
import Localized from '../landing/Localized';
import {
  SuccessResponse as CoreData,
} from './ExportGrowthDynamics';
import {
  HighlightedText,
  IntroText,
} from './SharedStyling';

const query = gql`
  query ExportGrowthComplexityTextComplexity($sectorOne: ID!, $sectorTwo: ID!, $year: Int!) {
    sectorOne: productYear(product: $sectorOne, year: $year) {
      complexityLevel
    }
    sectorTwo: productYear(product: $sectorTwo, year: $year) {
      complexityLevel
    }
  }
`;

interface Variables {
  sectorOne: string;
  sectorTwo: string;
  year: number;
}

interface ProductYearDatum {
  complexityLevel: ProductYear['complexityLevel'];
}

interface SuccessResponse {
  sectorOne: ProductYearDatum;
  sectorTwo: ProductYearDatum;
}

interface Props {
  variables: Variables;
  coreData: CoreData;
  fluentBundle: FluentBundle;
}

const ExportGrowthDynamicsText = (props: Props) => {
  const {
    variables, coreData, fluentBundle,
  } = props;


  const {loading, error, data} = useQuery<SuccessResponse, Variables>(query, {variables});
  let output: React.ReactElement<any> | null;

  if (loading === true) {
    output = null;
    } else if (error !== undefined) {
      console.error(error);
      output = null;
    } else if (data !== undefined) {
      const {location, countryLookback} = coreData;

      if (location === null || countryLookback === null) {

        output = null;
      } else {

        const {
          shortName, nameAbbr, thePrefix,
        } = location;
        const {
          largestContributingExportProduct: unfilteredProducts,
          exportValueGrowthClassification,
        } = countryLookback;
        const {sectorOne, sectorTwo} = data;
        const otherCategoryID = generateStringProductId({productClass: ProductClass.HS, id: 10});
        // Exclude "Other" product:
        const filteredProducts = unfilteredProducts.filter(item => item.topLevelParent.id !== otherCategoryID);
        const {namePrimary} = getCountryName({shortName, nameAbbr, thePrefix: Boolean(thePrefix)});
        const sectorOneName = filteredProducts[0].shortName;
        const sectorTwoName = filteredProducts[1].shortName;
        const IntroTextArgs = {
          'country-name': namePrimary,
          'growth-classification': exportValueGrowthClassification,
          'highest-export-complexity': sectorOne.complexityLevel,
          'second-export-complexity': sectorTwo.complexityLevel,
          'sectorOne': (
            <HighlightedText
              children={sectorOneName}
            />
          ),
          'sectorTwo': (
            <HighlightedText
              children={sectorTwoName}
            />
          ),
        };
        // output = null;
        output = (
          <Localized
            bundle={fluentBundle}
            messageId='export-growth-dynamics-text'
            messageArgs={IntroTextArgs}
          >
            <IntroText />
          </Localized>
        );
      }
    } else {

      output = null;
    }

  return output;
};

export default ExportGrowthDynamicsText;
